import {
    useEffect,
    useState
} from 'react';
import {useNavigate} from 'react-router-dom';
import {
    Button,
    Group,
    Loader,
    Stack,
    Text,
    Title
} from '@mantine/core';

export const WaitAndButtonComponent = () => {
    const navigate = useNavigate();
    const [wait, setWait] = useState(true);

    useEffect(() => {
        const timer = setTimeout(() => {
            setWait(false);
        }, 3000);

        return () => clearTimeout(timer);
    }, []);

    if (wait) {
        return <Stack gap={'xl'}>
            <Group>
                <Loader color={'white'} size={'sm'}/>
                <Title order={3}><Text>Checking current session...Please, wait!</Text></Title>
            </Group>
        </Stack>;
    }

    return (
        <Stack gap={'xl'}>
            <Title order={3}>Signed out. Please, sign in to continue.</Title>
            <Button onClick={() => navigate('/')}>Sign In</Button>
        </Stack>
    );
};
